import { ReviewCard } from './ui/ReviewCard.jsx'

export default ReviewCard
